import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getTernaryValue } from 'common/utilities/utils.js';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { useSelector } from 'react-redux';
const accordianParent = React.createRef();
const OrderDetail = props => {
  const {
    onClickHandler,
    currencyConversionFactor,
    isDarkMode = false,
    dataTestId,
    title,
    onEditOccasionName,
    itemId,
    itemName,
    showContent,
    setCurrentIndex,
    currentIndex,
    index,
  } = props;

  const { AccordianArrow, AccordianUpArrow, AccordianDownDark, AccordianUpDark } = IMAGE_PATH;
  const favoriteOrderData = useSelector(data => data.profileReducer?.favouriteOrders || []);
  const { flatResponse: { productMapById = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const clickHandler = event => {
    setCurrentIndex(getTernaryValue(currentIndex !== index, index, null));
    !showContent &&
      onClickHandler?.(itemId, favoriteOrderData, productMapById, accordianParent.current, currencyConversionFactor);
  };

  return (
    <div
      className={`global-accordian-container favorite-container-global ${showContent ? 'account-accordian-open' : ''}`}
      ref={accordianParent}
    >
      <div className='global-accordian-header-container'>
        <span className='global-accordian-header'>
          {title && (
            <div className='occasion-accordian-header-global'>
              <span className='order-accordian-heading'>{title}</span>
              <div
                className='edit-occasion-link'
                data-testid='edit-occasion-modal'
                onClick={() => {
                  onEditOccasionName(itemId, itemName);
                }}
              >
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.EDIT_FAVORITE_NAME)}
              </div>
            </div>
          )}
        </span>
        <div className='global-accordian-right'>
          {isDarkMode ? (
            <img
              src={(showContent && AccordianUpDark) || AccordianDownDark}
              onClick={clickHandler}
              className='global-accordian-arrow'
              data-testid='acordian-handle-dark'
              alt=''
            />
          ) : (
            <img
              src={(showContent && AccordianUpArrow) || AccordianArrow}
              onClick={clickHandler}
              className='global-accordian-arrow'
              data-testid={dataTestId}
              alt=''
            />
          )}
        </div>
      </div>
      {showContent && <div className='global-accordian-content'>{props.children}</div>}
    </div>
  );
};

export default OrderDetail;
